"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { FaArrowRight } from "react-icons/fa"; // Importing arrow icon from react-icons

const Intro = () => {
  return (
    <div>
      <section className="py-10 md:py-16">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6 lg:gap-12 items-start justify-between">
            {/* Image Section */}
            <div className="relative w-full h-full lg:order-1">
              <Image
                src="/images/Air-Ticket-Services.jpg"
                alt="Air Ticket Services"
                fill
                className="object-cover"
              />
            </div>

            {/* Text Section */}
            <div className="lg:order-2">
              <h2 className="font-medium text-color-blue-600 my-3">
                Air Ticket Services
              </h2>
              <ul className="space-y-3 mb-4 text-lg font-sans">
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-7 h-7" />
                  We offer competitive Air Fares for marine as well as corporate
                  and leisure travel with Global alliances in 80 countries.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-5 h-5" />
                  Our teams provide updating “Ok to Board” for passengers
                  travelling on “Visa on Arrival.”
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  Our team is trained to provide skilled service in emergency
                  situations.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  We provide complete transparent solutions with GDS access.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  We arrange air travel for all nationalities.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  We provide meet and assist services at airports for VIP
                  passengers.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  We do not charge services fees on cancelled and reissued
                  tickets.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-6 h-6" />
                  We generate savings for our customers by charging service fees
                  per passenger and not per ticket.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  We offer discounts to our customers on total volumes.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Intro;
